// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ClipboardController from "./clipboard_controller";

application.register("clipboard", ClipboardController);

import RecoveryCodeDownloadController from "./recovery_code_download_controller";

application.register("recovery-code-download", RecoveryCodeDownloadController);

import DropdownController from "./dropdown_controller";

application.register("dropdown", DropdownController);

import EmailController from "./email_controller";

application.register("email", EmailController);

import EmailConfirmationController from "./email_confirmation_controller";

application.register("email-confirmation", EmailConfirmationController);

import FormWithCaptchaController from "./form_with_captcha_controller";

application.register("form-with-captcha", FormWithCaptchaController);

import UserMenuController from "./user_menu_controller";

application.register("user-menu", UserMenuController);

import WebauthnController from "./webauthn_controller";

application.register("webauthn", WebauthnController);
